import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const resolveTokenLabels = api(async function resolveTokenLabels({ tokenIds } = {}) {
    return query(
        gql`
            query ResolveTokenLabels($tokenIds: [String!]!) {
                resolveTokenLabels(tokenIds: $tokenIds) {
                    tokenId
                    label
                    content
                    found
                }
            }
        `,
        { tokenIds },
        { returns: "resolveTokenLabels" }
    )
})
